/**
 * Supabase/PostgREST often rejects with plain objects. CRA's overlay shows them as "[object Object]".
 */
export function messageFromUnknownError(error: unknown): string {
  if (error == null) return 'Unknown error';
  if (typeof error === 'string') return error;
  if (error instanceof Error) return error.message || String(error);
  if (typeof error === 'object') {
    const o = error as Record<string, unknown>;
    const msg = o.message != null ? String(o.message) : '';
    const details = o.details != null ? String(o.details) : '';
    const hint = o.hint != null ? String(o.hint) : '';
    const code = o.code != null ? String(o.code) : '';
    const parts = [msg, details || hint, code ? `(${code})` : ''].filter(Boolean);
    if (parts.length > 0) return parts.join(' — ');
    try {
      return JSON.stringify(error);
    } catch {
      return 'Request failed';
    }
  }
  return String(error);
}
